module.exports = __webpack_public_path__ + "img/71_28.2e4407ff.png";